function getLoyaltyAccountTier(state: App.State): App.LoyaltyTier | undefined {
  return state.loyalty.account.data?.tier
}

export default getLoyaltyAccountTier
